export default __webpack_public_path__ + "9c240384b20b86fc59c393134fe91f50.jpg";